import './style.sass';

import FullWrapper from 'core/FullWrapper';

const Target = () => {
    return (
        <div className="moscowExchange-target">
            <FullWrapper>
                <div className="moscowExchange-targetWrapper">
                    <div className="moscowExchange-targetLeft">Цель</div>
                    <div className="moscowExchange-targetRight">
                        Увеличить трафик из&nbsp;поисковых систем на&nbsp;приоритетных направлениях
                        для сайтов finuslugi.ru и&nbsp;moex.com
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;
